<app-layer-config-collapsible-category
  class="border-bottom border-darkgray"
  [description]="description"
  storageKey="property-filters-key"
  [collapsedDefault]="false"
>
  <div class="property-filters">
    @if (activeCustomFilters.length > 0) {
      <div class="property-filters__chips">
        @for (f of activeCustomFilters; track f.key) {
          <button
            type="button"
            class="property-filters__chip"
            (click)="removeCustomFilter(f.key)"
            [attr.aria-label]="'Remove filter ' + f.key"
          >
            <span class="property-filters__chip-label"
              >{{ f.key }}<span class="property-filters__chip-sep">=</span>{{ f.value }}</span
            >
          </button>
        }
        <button type="button" class="property-filters__clear-all" (click)="clearCustomFilters()">
          Clear all
        </button>
      </div>
    }
    <div class="property-filters__input-row">
      <input
        class="property-filters__input"
        type="text"
        [(ngModel)]="customFiltersInput"
        placeholder="key=value, keyIn=a|b, keyContains=text"
        (keydown.enter)="applyCustomFilters()"
        aria-label="Custom property filters"
      />
      <button
        type="button"
        class="property-filters__apply-btn"
        [disabled]="!customFiltersInput"
        (click)="applyCustomFilters()"
        aria-label="Apply filter"
      >
        <span class="rb-ic rb-ic-checkmark"></span>
      </button>
    </div>
    <p class="property-filters__hint">
      <code>key=value</code>, <code>keyIn=a|b</code> or <code>keyContains=text</code>, "," key...
    </p>
  </div>
</app-layer-config-collapsible-category>
